/**
 * Brand chip used across every page's header/nav. Uses the hand-drawn
 * DepotSeal SVG at a small, header-friendly size.
 */
import { DepotSeal } from "@/components/DepotSeal";
import { Link } from "react-router-dom";

export function BrandChip({ size = 40, to = "/", showWordmark = false, className = "" }) {
  const inner = (
    <>
      <DepotSeal size={size} className="text-amber-500 shrink-0" showEst={false} />
      {showWordmark && (
        <div className="hidden sm:flex flex-col leading-none">
          <span className="text-[9px] text-amber-500 uppercase tracking-[0.32em] font-semibold mb-0.5">
            North American
          </span>
          <span className="font-serif text-[16px] font-semibold tracking-tight text-white">
            Depots<span className="text-amber-500"> &amp; </span>Towers
          </span>
        </div>
      )}
    </>
  );
  if (!to) return <div className={`flex items-center gap-3 ${className}`}>{inner}</div>;
  return (
    <Link to={to} className={`flex items-center gap-3 group ${className}`}>
      {inner}
    </Link>
  );
}
